import { render, staticRenderFns } from "./results-primary-link.vue?vue&type=template&id=66192758&"
import script from "./results-primary-link.vue?vue&type=script&lang=js&"
export * from "./results-primary-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports